<template>
  <div class="drawer-wrap">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-drawer
      title="学员积分"
      :visible.sync="dialogVisible"
      direction="rtl"
      :size="520"
      destroy-on-close
      append-to-body
    >
      <div class="content-wrap">
        <el-form
          size="mini"
          :model="form"
          label-width="120px"
          ref="mainForm"
          :rules="rules"
          class="main-form"
        >
          <el-form-item label="学员名称:">
            <el-input v-model="studentDetail.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号:">
            <el-input v-model="studentDetail.mobile" disabled></el-input>
          </el-form-item>
          <el-form-item label="有效积分:">
            <el-input v-model="studentDetail.old" disabled></el-input>
          </el-form-item>
          <el-form-item label="充值类型:" prop="integral">
            <el-radio-group v-model="form.type">
              <el-radio-button :label="1">增加积分</el-radio-button>
              <el-radio-button :label="2">扣除积分</el-radio-button>
            </el-radio-group>
            <div class="integral-wrap">
              <el-input
                v-model.number="form.integral"
                placeholder="请输入"
                type="number"
                clearable
              ></el-input>
              <span class="tail">积分</span>
            </div>
          </el-form-item>
          <el-form-item label="备注说明:" prop="remark">
            <el-input
              v-model="form.remark"
              type="textarea"
              maxlength="255"
              placeholder="请输入备注说明"
              :rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <div class="btns">
            <div class="mwow-button-filled mini" @click="handleClose">取消</div>
            <div class="mwow-button-filled mini success" @click="handleSubmit">
              保存
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { studentDetail } from "@/api/studyDetails";
import { changeStudentIntegralApi } from "@/api/studentManage";
import { positivePass } from "@/utils/rules";

export default {
  // @Prop() studentId!: number;
  props: ["studentId"],
  data() {
    return {
      studentDetail: {
        name: "",
        mobile: "",
        old: "",
      },
      form: {
        student_id: this.studentId,
        type: 1,
        integral: 1,
        remark: "",
      },
      dialogVisible: false,
      rules: {
        integral: [
          { required: true, message: "请输入积分数量", trigger: "blur" },
          { validator: positivePass, trigger: "blur" },
        ],
        remark: [
          { required: true, message: "请输入备注信息", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    openDialog() {
      if (!this.studentId) {
        return false;
      }
      studentDetail({ student_id: this.studentId }).then((res) => {
        this.studentDetail = {
          name: res.data.name,
          mobile: "+" + res.data.area_code + " " + res.data.mobile,
          old: res.data.integral ? res.data.integral.usable : 0,
        };
      });
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          changeStudentIntegralApi({
            student_id: this.studentId,
            type: this.form.type,
            integral: this.form.integral,
            remark: this.form.remark,
          }).then(() => {
            this.$message({
              type: "success",
              message: `积分已${this.form.type === 1 ? "增加" : "扣除"}`,
            });
            this.handleClose();
            this.$emit("change");
            this.form = {
              student_id: this.studentId,
              type: 1,
              integral: 1,
              remark: "",
            };
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.drawer-wrap {
  display: inline-block;
}
.content-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  .main-form {
    flex: 1;
    padding: 23px 120px 23px 0;
  }
  .footer {
    padding: 22px 18px;
    .btns {
      text-align: right;
      .mwow-button-filled {
        margin-left: 10px;
      }
    }
  }
}
.integral-wrap {
  .el-input {
    margin-top: 20px;
    width: 246px;
  }
  .tail {
    font-size: 12px;
    color: #5c5d5e;
    margin-left: 10px;
  }
}
</style>
